// ExpressionHeatmap.jsx
import React from "react";
import Plot from "react-plotly.js";

function ExpressionHeatmap({ cells, genes, matrix }) {
  if (!matrix || !cells?.length || !genes?.length) return null;

  const estimatedHeight = Math.max(Math.min(500 + cells.length * 1, 4000), 600);

  return (
    <div className="mt-6">
      <Plot
        data={[
          {
            z: matrix,
            x: genes,
            y: cells,
            type: "heatmap",
            colorscale: "YlGnBu",
            colorbar: { title: "Expression" },
          },
        ]}
        layout={{
          title: "Expression Heatmap (Cells × Genes)",
          xaxis: { title: "Genes" },
          yaxis: { title: "Cells" },
          height: estimatedHeight,
        }}
        useResizeHandler={true}
        style={{ width: "100%"}}
        config={{ responsive: true }}
      />
    </div>
  );
}

export default ExpressionHeatmap;
